<template>
    <div>

        <div class="colwrap">
            <div class="col head">bis 25%</div>
            <div class="col head">bis 50%</div>
            <div class="col head">unter 100%</div>
            <div class="col head">100%</div>
        </div>
        <div class="bar" v-bind:style="{ width: barwidth }">
            <span v-bind:class="{ small: quote<10.1}">{{quote|formatNumber}}%</span>
        </div>
        <div class="colwrap">
            <div class="col zinssatz" v-bind:class="{ active: zinssatz==0.1}">+ 0,10% <sup>(3)</sup></div>
            <div class="col zinssatz" v-bind:class="{ active: zinssatz==0}">+ 0,00%</div>
            <div class="col zinssatz" v-bind:class="{ active: zinssatz==-0.4}">- 0,40%</div>
            <div class="col zinssatz" v-bind:class="{ active: zinssatz==-0.5}">- 0,50%</div>
        </div>
        <div style=" margin-top:5px;color: rgba(42, 98, 188, 0.47);font-size: 16px">
            <label>Verwahrentgeldsatz </label>  p.a.
        </div>
    </div>

</template>
<script type="text/babel">

    export default {
        name: 'Bar2d',
        props: {
            quote: {
                type: Number,
                required: true
            },
            zinssatz: {
                type: Number,
                required: true
            },
        },

        computed: {

            barwidth() {
                if (this.quote <= 50 || this.quote === 100)
                    return this.quote + '%';


                let RestProzent = (this.quote - 50) * 2;

                // console.log('RestProzent: '+RestProzent);


                let relProzent = (25 / 100 * RestProzent);
                //  console.log('relProzent: '+relProzent);

                let angepassteBreite = 50 + relProzent;
                //  console.log('angepassteBreite: '+angepassteBreite);


                return angepassteBreite + '%';

            },

        },
    }
</script>

<style lang="scss" scoped>

    .colwrap {
        display: flex;

        .col {
            flex: 1;

            &.head {
                font-size: 16px;
                text-align: center;
                border-right: 1px rgba(255, 102, 0, 1) solid;

                padding: 5px;


                //border-bottom: 30px rgba(255, 255, 255, 0.33) solid;
                margin-bottom: 30px;

                background-color: rgba(255, 102, 0, .5);
            }

            &.zinssatz {

                color: white;
                background-color: rgba(42, 98, 188, 0.47);
                text-align: center;
                padding: 5px;

            }

            &.active {
                background-color: #2a62bc;
                font-weight: bold;
            }
        }
    }

    .bar {
        margin-top: -30px;
        bottom: 0;
        background-color: rgba(255, 102, 0, 1);
        color: white;
        font-weight: bold;
        text-align: center;
        transition: width 2s;
        line-height: 30px;
        height: 30px;
        overflow: visible;
        white-space: nowrap;

        span.small {
            position: absolute;
            color: black;
        }
    }

</style>
